/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTThemeSwitch } from './theme-switch';
export type {
	KTThemeSwitchConfigInterface,
	KTThemeSwitchInterface,
} from './types';
